export default "__VITE_ASSET__BnpvOY5q__"